<script>
export default {
  name: "DidoDownloadItemMillesime",
};
</script>

<script setup>
import DidoDownloadButtonMillesime from "../buttons/Millesime.vue";

// define Props
const props = defineProps({
  apiUrl: { type: String, required: true },
  millesimeObject: { type: Object, required: true },
  selectable: { type: Boolean, required: false, default: false },
  selectedLinks: { type: Array, required: false, default: () => [] },
});

// define Emits
defineEmits(["update-selected-links"]);
</script>

<template>
  <QItem>
    <!-- Icon -->
    <QItemSection avatar title="Millésime de fichier de données">
      <QIcon name="mdi-table-large" size="xs" color="secondary" />
    </QItemSection>
    <!-- Title and Millesime -->
    <QItemSection>
      <!-- Title -->
      <QItemLabel
        class="text-secondary"
        lines="1"
        :title="props.millesimeObject.description"
      >
        {{ props.millesimeObject.title }}
      </QItemLabel>
      <!-- Millesime -->
      <QItemLabel
        class="text-grey"
        caption
        lines="1"
        :title="`Millésime ${props.millesimeObject.millesime}`"
      >
        Millésime {{ props.millesimeObject.millesime }}
      </QItemLabel>
    </QItemSection>
    <!-- Dropdown Button for selection of Download format -->
    <QItemSection side>
      <DidoDownloadButtonMillesime
        :millesime-object="props.millesimeObject"
        :api-url="props.apiUrl"
        :selectable="props.selectable"
        :selected-links="props.selectedLinks"
        @update-selected-links="$emit('update-selected-links', $event)"
      />
    </QItemSection>
  </QItem>
</template>
